<template>
  <div id="modal-edit-statement">
    <form @submit.prevent="saveQuotes">
      <div class="form-group">
        <label for="speaker">Pembicara</label>
        <input type="text" class="form-control" id="speaker" v-model="speaker" required />
      </div>
      <div class="form-group">
        <label for="sentiment">Sentimen</label>
        <select class="form-control" v-model="sentiment">
          <option value="null" selected disabled>--Pilih Sentimen--</option>
          <option value="1">Positif</option>
          <option value="0">Netral</option>
          <option value="-1">Negatif</option>
        </select>
      </div>
      <div class="form-group">
        <label for="quote">Pernyataan</label>
        <quil-editor class="editor" name="quote" v-model="quote" :options="editorOption" />
      </div>
      <div class="form-group custom-margin-top" align="right">
        <button type="button" class="btn btn-danger mr-2" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-warning">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import notif from "@/assets/js/notif.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "modal_edit_statement",
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    "quil-editor": quillEditor,
  },
  data() {
    return {
      speaker: this.data.speaker,
      quote: this.data.quote,
      sentiment: this.data.sentiment,
      id_project: this.$store.getters.user.id_project,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline"]],
        },
      },
    };
  },
  methods: {
    saveQuotes: function () {
      let api = process.env.VUE_APP_API_URL + "quotes-update";
      let data = {
        id: this.data._id.$oid,
        speaker: this.speaker,
        quote: this.quote,
      };
      if (this.sentiment != null) {
        data.sentiment = Number(this.sentiment);
      }
      this.$http
        .post(api, data)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Data berhasil disimpan!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          } else {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "warning",
              })
              .show();
          }
        })
        .catch(() => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> Terjadi kesalahan, silakan coba lagi!',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.$("#modal-edit-quotes").modal("hide");
          this.$parent.$parent.$parent.getData(true);
        });
    },
  },
  created: function () {
    this.$.pgNotification = notif;
  },
};
</script>

<style scoped>
.editor {
  height: 225px;
}

.custom-margin-top {
  margin-top: 90px;
}
</style>